/* Option lists shared by the Custom recurrence panels.
   The month and weekday lists in data/data.json use short codes as values
   ("jan", "mon") and are still read by other parts of the app, so these mirror
   them rather than replacing them. */

export const ORDINALS = [
  { value: "first", label: "first" },
  { value: "second", label: "second" },
  { value: "third", label: "third" },
  { value: "fourth", label: "fourth" },
  { value: "last", label: "last" },
];

export const WEEKDAYS = [
  { value: "sun", label: "Sunday" },
  { value: "mon", label: "Monday" },
  { value: "tue", label: "Tuesday" },
  { value: "wed", label: "Wednesday" },
  { value: "thu", label: "Thursday" },
  { value: "fri", label: "Friday" },
  { value: "sat", label: "Saturday" },
];

export const MONTHS = [
  { value: "jan", label: "January" },
  { value: "feb", label: "February" },
  { value: "mar", label: "March" },
  { value: "apr", label: "April" },
  { value: "may", label: "May" },
  { value: "jun", label: "June" },
  { value: "jul", label: "July" },
  { value: "aug", label: "August" },
  { value: "sep", label: "September" },
  { value: "oct", label: "October" },
  { value: "nov", label: "November" },
  { value: "dec", label: "December" },
];

export const labelOf = (list, value) => (list.find((item) => item.value === value) || {}).label || value;
